import React, { useEffect, useState } from "react";
import Styles from "./styles.module.scss"
import Headline4 from '../../compopnents/headings/Headline4';
import ellowLogo from "../../assets/images/ellow-logo.svg";


function Acknowledgement(props: any) {


  useEffect(() => {

   if(props){
        setStartDate(new Date(parseInt(props.startDate)).toDateString())
        setEndDate(new Date(parseInt(props.endDate)).toDateString())
   }
  }, [])

  const [startDate , setStartDate] = useState<any>()
  const [endDate , setEndDate] = useState<any>()

  return (
    <section className="dashboardWrapper">
        <div className="dashboardContent">
            <div className={Styles.header}>
                <img src={ellowLogo} alt="ellow.io" />
            </div>
            {props.rejectComment === undefined &&
                <div className={Styles.certificationCard}>
                <div className={Styles.ratingHead}>
                    <div className="text-center mt-50">
                        <Headline4><span className="green-text">Thank you!</span></Headline4>
                        <p>" Thanks for approving the timesheet , We will be updating the candidate on the same. "</p>
                    </div>
                </div>  
                </div>
            }
            {props.rejectComment !== undefined &&
                <div className={Styles.certificationCard}>
                <div className={Styles.ratingHead}>
                    <div className="text-center mt-50">
                        <Headline4><span className="green-text">Thank you!</span></Headline4>
                        <p>" Thanks for the udpate , The Timesheet by the <span>{props.candidate_name}</span> from <span>{startDate }</span> to <span>{endDate} </span>has been rejected, We will update the candidate accordingly. "</p>
                        <p>" The reason for rejection is <span>{props.rejectComment}</span>."</p>
                    </div>
                </div>  
                </div>
            }
        </div>
    </section>
  );
}

export default Acknowledgement;
